import { FC } from 'react';
import { Card, Button, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
  faCopy,
} from '@fortawesome/free-regular-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import type { UseFormSetValue } from 'react-hook-form';
import Flex from '../../../../../../components/common/Flex';
import { DoExtensionFormValues } from '../validation/doExtensionValidation';
import { encryptAndEncode } from '../../../../../../encrypt-util';
import { openDocumentInNewTab } from '../../../../../../helpers/openDocumentInNewTab';


type Props = {
  t: any;
  displayNumber: string;
  handleBack: () => void;
  handleCopyBL: (e: React.MouseEvent) => void;
  templateList: any[];
  demurrageViewForm: any;
  setValue: UseFormSetValue<DoExtensionFormValues>;
  selectedLinerId: any;
  profileDetails: any;
  instructionLoading: boolean;
};

const DOExtensionHeader: FC<Props> = ({
  t,
  displayNumber,
  handleBack,
  handleCopyBL,
  templateList,
  demurrageViewForm,
  setValue,
  selectedLinerId,
  profileDetails,
  instructionLoading
  
}) => {
  return (
    <Card.Header
      className='d-flex align-items-center border-bottom bg-white sticky-top'
      style={{ zIndex: 10 }}>
      <FontAwesomeIcon
        icon={faArrowAltCircleLeft}
        className='text-warning cursor-pointer fa-lg me-1 mb-2'
        onClick={handleBack}
      />
      <div className='d-flex align-items-center flex-wrap gap-7 mb-1'>
        <div className='d-flex align-items-center gap-5 mb-1'>
          <h2 className='fs-0 text-primary mb-0 mb-lg-0'>
            {t('resource_3:extensionForDORequest')}
          </h2>

          {displayNumber && (
            <div className='d-flex align-items-center'>
              <span className='text-muted me-2'>BL No.</span>
              <span className='fw-bold me-2'>{displayNumber}</span>
              <button
                className='btn btn-link p-0'
                onClick={handleCopyBL}
                title='Copy BL number'>
                <FontAwesomeIcon icon={faCopy} className='text-primary' />
              </button>
            </div>
          )}
        </div>
        {templateList &&
          !demurrageViewForm.dndInstructionId &&
          templateList.length > 0 && profileDetails?.partnerType !== 'liner' && instructionLoading===false && (
            <div className='d-flex align-items-left ms-3'>
              <Dropdown>
                <Dropdown.Toggle
                  bsPrefix='toggle'
                  as={Link}
                  to='#!'
                  className='pe-0 ps-2 nav-link '
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}>
                  <Flex
                    direction='row'
                    justifyContent='end'
                    alignItems='end'
                    alignContent=''
                    inline=''
                    wrap=''
                    className='justify-content-end'
                    style={{ width: '100%' }}
                    breakpoint=''>
                    <Button
                      style={{
                        width: 'auto',
                        marginLeft: 'auto',
                        display: 'block',
                      }}
                      variant='ms-3 btn btn-falcon-primary z-inxe-agent btn-sm'
                      size='lg'
                      title='Download Document'
                      className='ms-3'>
                      <FontAwesomeIcon
                        icon={faDownload}
                        className='me-2 '
                        style={{ fontSize: '14px', color: '#f5822a' }}
                        title='Download Document'
                      />
                      <span style={{ fontSize: 12 }}>
                        {t('resource_2:downloadTemplate')}
                      </span>
                    </Button>
                  </Flex>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {templateList.map((tpl: any) => (
                    <Dropdown.Item
                      key={tpl.code}
											onClick={async () => {
											  setValue('doNumber', tpl.doNumber ?? '');

											  await openDocumentInNewTab({
											    url: '/api/edo-rest-v2/v2/common/openDocument',
											    params: {
											      id: encryptAndEncode(tpl.code),
											      moduleTp: 'INSTRUCTION_DOC',
											      linerId: encryptAndEncode(selectedLinerId),
											    },
											  });
											}}>
                      {tpl.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
      </div>
      {/* tnc badge block kept commented as in original */}
    </Card.Header>
  );
};

export default DOExtensionHeader;